import React from 'react';
import { createComponent } from '@lit-labs/react';
import { ClbText as ClbText_ } from '@celebration/design-system/dist/lib/text';
export const ClbText = createComponent({
    tagName: ClbText_.tagName,
    elementClass: ClbText_,
    react: React,
    events: {},
});
//# sourceMappingURL=index.js.map